<template>
    <v-card
        class="px-2"
        :class="{ 'match-card-clickable': hasMatchId }"
        width="300px"
        :ripple="hasMatchId"
        :tabindex="hasMatchId ? 0 : -1"
        role="button"
        @click="goToMatch"
        @keydown.enter.prevent="goToMatch"
        @keydown.space.prevent="goToMatch"
    >
        <v-row
            :style="match.scoreTeam2 > match.scoreTeam1 ? 'filter: grayscale(1);' : ''"
            align="center"
            :class="match.scoreTeam2 > match.scoreTeam1 ? '' : 'custom-teal-text'"
            @mouseenter="emitTeamHover(match.team1)"
            @mouseleave="emitTeamLeave"
        >
            <v-col cols="8" align="center">
                <v-avatar style="border-radius: 10px;" size="30" color="white">
                    <img
                        :src="`${assetsUrl}/${match.team1.logo}`"
                        height="30px"
                        contain
                    >
                </v-avatar>
                {{ match.team1.name }}
            </v-col>
            <v-col cols="4" align="center">
                <div>{{ match.scoreTeam1 }}</div>
            </v-col>
        </v-row>
        <v-divider />
        <v-row
            :style="match.scoreTeam1 > match.scoreTeam2 ? 'filter: grayscale(1);' : ''"
            align="center"
            :class="match.scoreTeam1 > match.scoreTeam2 ? '' : 'custom-teal-text'"
            @mouseenter="emitTeamHover(match.team2)"
            @mouseleave="emitTeamLeave"
        >
            <v-col cols="8" align="center">
                <v-avatar style="border-radius: 10px;" size="30" color="white">
                    <img
                        :src="`${assetsUrl}/${match.team2.logo}`"
                        height="30px"
                        contain
                    >
                </v-avatar>
                {{ match.team2.name }}
            </v-col>
            <v-col cols="4" align="center">
                {{ match.scoreTeam2 }}
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
    export default {
        props: {
            match: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        computed: {
            hasMatchId() {
                return Boolean(this.match?.id)
            }
        },
        methods: {
            getTeamId(team) {
                return Number(team?.id || team?.teamId || team?.team_id || 0)
            },
            emitTeamHover(team) {
                const teamId = this.getTeamId(team)
                if (!teamId) return

                this.$emit('team-hover', {
                    teamId,
                    matchId: Number(this.match?.id || 0)
                })
            },
            emitTeamLeave() {
                this.$emit('team-leave')
            },
            goToMatch() {
                if (!this.hasMatchId) return
                this.$router.push({ name: 'Match', params: { id: this.match.id } })
            }
        }
    }
</script>

<style scoped>
    .match-card-clickable {
        cursor: pointer;
    }
</style>
